import {Component, Input} from '@angular/core';
import {GLOBAL, PropertiesQuery} from "common-shared";
import {FilterMatchMode} from "primeng/api";

@Component({
  selector: '[app-spec-column-filter]',
  templateUrl: './spec-column-filter.component.html',
  styles: [
  ],
})
export class SpecColumnFilterComponent {
  Classificators = GLOBAL.Classificators;
  @Input() spec: string;
  @Input() allSpecs: { Key: string, Value: any[] }[] = [];

  choiceMatchModeOptions = [
    {label: 'Equals', value: FilterMatchMode.EQUALS},
    {label: 'Not Equals', value: FilterMatchMode.NOT_EQUALS},
    {label: 'Contains', value: FilterMatchMode.CONTAINS},
    {label: 'Not Contains', value: FilterMatchMode.NOT_CONTAINS},
    {label: 'Exists', value: 'exists'},
    {label: 'Not Exists', value: 'notExists'},
  ];

  numericMatchModeOptions = [
    {label: 'Equals', value: FilterMatchMode.EQUALS},
    {label: 'Not Equals', value: FilterMatchMode.NOT_EQUALS},
    {label: 'Contains', value: FilterMatchMode.CONTAINS},
    {label: 'Not Contains', value: FilterMatchMode.NOT_CONTAINS},
    {label: 'Exists', value: 'exists'},
    {label: 'Not Exists', value: 'notExists'},
    {label: 'Less than', value: FilterMatchMode.LESS_THAN},
    {label: 'Less than or equal to', value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO},
    {label: 'Greater than', value: FilterMatchMode.GREATER_THAN},
    {label: 'Greater than or equal to', value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO}
  ];

  dateMatchModeOptions = [
    {label: 'Date is', value: FilterMatchMode.DATE_IS},
    {label: 'Date is not', value: FilterMatchMode.DATE_IS_NOT},
    {label: 'Date is before', value: FilterMatchMode.DATE_BEFORE},
    {label: 'Date is after', value: FilterMatchMode.DATE_AFTER},
    {label: 'Exists', value: 'exists'},
    {label: 'Not Exists', value: 'notExists'},
  ]
  constructor(public propertiesQuery: PropertiesQuery) {
  }
}
